<div class="mb-3">
  <ng-container *ngIf="showVariantDescription && subscription.variantDescription && showOrderNo">
    <div class="form-group col-12">
      <div class="row">
        <div class="col-12 col-sm-6"
             [innerHTML]="translationService.getTranslation('order_id') + ': ' + subscription.backendId">
        </div>
      </div>
    </div>
  </ng-container>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('period') + ': ' + (subscription.validDate.validFrom | date) + ' - ' + ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date) : translationService.getTranslation('subscription_endless'))">
      </div>
    </div>
  </div>
  <div class="form-group col-12" *ngIf="subscription.commitmentDate && subscription.commitmentDate > today">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('period') + ': ' + (subscription.validDate.validFrom | date) + ' - ' + ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date) : translationService.getTranslation('subscription_endless'))">
      </div>
    </div>
  </div>
  <div *ngIf="showProductDescription" class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('order_product') + ': ' + subscription.productDescription">
      </div>
    </div>
  </div>
  <ng-container *ngIf="showVariantDescription && subscription.variantDescription">
    <div class="form-group col-12">
      <div class="row">
        <div class="col-12 col-sm-6"
             [innerHTML]="translationService.getTranslation('order_edition') + ': ' + subscription.variantDescription">
        </div>
      </div>
    </div>
  </ng-container>
</div>
